/* eslint-disable indent */
import React from 'react'

import SortableButton from '../SortableButton'
import Tooltip from '../Tooltip'

import { Tr, Th, ThContentCell } from './styles'

const HeadRow: React.FC<HeadRow> = ({
  schema,
  sideBorder,
  focusColumn,
  total,
  activeSortKey,
  activeSortDirection,
  onSort
}) => (
  <Tr>
    {Object.keys(schema).map((key, index) => {
      const currentSchema = schema[key]

      return (
        <Th
          key={index}
          sideBorder={sideBorder}
          activeColumn={focusColumn === key}
          width={currentSchema.width}
          className={`${currentSchema.className || ''} ${
            currentSchema.classNameTH || ''
          }`}
        >
          <ThContentCell
            className="contentCell"
            as={currentSchema?.sortKey ? 'button' : 'div'}
            {...(currentSchema?.sortKey
              ? {
                  onClick: () =>
                    onSort?.({
                      key: currentSchema.sortKey,
                      sortInitialDirection:
                        currentSchema.sortInitialToggleDirection
                    })
                }
              : null)}
          >
            {typeof currentSchema.title === 'function' ? (
              <currentSchema.title total={total} />
            ) : (
              (currentSchema.title || currentSchema.showTotal) && (
                <div className="mainInfo d-flex align-items-center">
                  <span className="text">
                    {currentSchema.helpContent || currentSchema.helpText ? (
                      <Tooltip
                        noMargin
                        title={currentSchema.helpTitle ?? currentSchema.title}
                        text={
                          currentSchema.helpContent ?? currentSchema.helpText
                        }
                      >
                        {currentSchema.title}
                      </Tooltip>
                    ) : (
                      currentSchema.title
                    )}

                    {currentSchema.showTotal && (
                      <>
                        {' '}
                        <span>
                          ({Number(total) > 100000 ? '+99.999' : total}{' '}
                          {total > 1 ? 'itens' : 'item'})
                        </span>
                      </>
                    )}
                  </span>

                  {currentSchema.headerSuffix && (
                    <div className="headerSuffix d-flex align-items-center ms-1">
                      {currentSchema.headerSuffix}
                    </div>
                  )}
                </div>
              )
            )}

            {!!currentSchema?.sortKey && (
              <aside>
                {!!currentSchema?.sortKey && (
                  <SortableButton
                    isActive={activeSortKey === currentSchema.sortKey}
                    direction={activeSortDirection}
                  />
                )}
              </aside>
            )}
          </ThContentCell>
        </Th>
        // )
      )
    })}
  </Tr>
)

export default HeadRow
